var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FF9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 45.999V41.5463C18 40.6451 18.2555 39.8172 18.7665 39.0623C19.2775 38.3075 19.9553 37.7307 20.8 37.3321C22.6083 36.5105 24.4458 35.8945 26.3125 35.4842C28.1792 35.0739 30.075 34.8683 32 34.8672C33.925 34.8661 35.8208 35.0718 37.6875 35.4842C39.5542 35.8966 41.3917 36.5126 43.2 37.3321C44.0458 37.7297 44.7242 38.3064 45.2352 39.0623C45.7462 39.8182 46.0012 40.6462 46 41.5463V45.999H18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0017 25.9531C25.0017 26.9743 25.2352 27.9097 25.7021 28.7593C26.0351 29.3642 26.4865 29.9257 27.0563 30.4436C28.4271 31.6896 30.075 32.3126 32 32.3126C33.925 32.3126 35.5729 31.6896 36.9438 30.4436C38.3146 29.1976 39 27.6997 39 25.95L39 24.3625C39 23.3413 38.7665 22.406 38.2996 21.5564C37.9665 20.9502 37.5145 20.3878 36.9438 19.869C35.5729 18.623 33.925 18 32 18C30.075 18 28.4271 18.623 27.0563 19.869C25.7249 21.0791 25.0401 22.5267 25.0017 24.2119V25.9531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.f0031ba131443896bc07e99d3f3c1a6f.svg";
export { ForwardRef as ReactComponent };